import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const AppSumoOAuth = () => {
	const { search } = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		const urlParams = new URLSearchParams(search);
		const appsumoCode = urlParams.get('code');

		if (appsumoCode) {
			// Redirect to login page with appsumo_code parameter
			navigate(`/login?code=${appsumoCode}`);
		} else {
			// If no code, redirect to login without parameter
			navigate('/login');
		}
	}, [search, navigate]);

	return null;
};

export default AppSumoOAuth;


